import React from "react";
import PropTypes from "prop-types";
import { Button } from "../Button";
import { Dialog } from "../Dialog";

/**
 * Confirm dialog for destructive actions (delete / remove).
 */
export function ConfirmDialog({
  open,
  onClose,
  onConfirm,
  title = "Confirm",
  confirmLabel = "Remove",
  cancelLabel = "Cancel",
  busy = false,
  children,
}) {
  return (
    <Dialog
      open={open}
      onClose={busy ? undefined : onClose}
      title={title}
      width={420}
      footer={
        <>
          <Button variant="secondary" onClick={onClose} disabled={busy}>
            {cancelLabel}
          </Button>
          <Button variant="destructive" onClick={onConfirm} disabled={busy}>
            {busy ? "Working…" : confirmLabel}
          </Button>
        </>
      }
    >
      {children}
    </Dialog>
  );
}

ConfirmDialog.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  onConfirm: PropTypes.func,
  title: PropTypes.node,
  confirmLabel: PropTypes.string,
  cancelLabel: PropTypes.string,
  busy: PropTypes.bool,
  children: PropTypes.node,
};

export default ConfirmDialog;
